// Query keys
export const RECOMMENDED_PASSES_QUERY_KEY =
	'FETCH_RECOMMENDED_PASSES_:productId';
export const PRICES_FOR_PASS_QUERY_KEY = 'FETCH_PRODUCT_PRICES_:productId';
